module.exports = __webpack_public_path__ + "img/ball.2147b737.png";